export const storageVariableNames: any = {
  calendarView: 'calendarView'
};
